import { createContext } from "react";

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {

  const ApiUrl = 'https://apis.royalbakery.co.in/';
  const apiHeaderJson = { 'Content-Type': "application/json", key: 28 }


  let social_media = {
    instagram: `https://www.instagram.com/royalbakery.co.in?igsh=MWJ5dW12cXR2bGRyMw%3D%3D&utm_source=qr`,
    facebook: `https://www.facebook.com/share/1HyvBUDF6A/?mibextid=wwXIfr`,
    twitter: `https://x.com/royalbakery_?s=11&t=jjjSrHoDNg44BdmOoB1TYg`,
  }

  const createSlug = (name) => {
    if (!name) {
      return;
    }

    const slug = name.toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

    return slug;
  }



  const vals = {
    appName: "Royal Bakery",
    tollFreeNumber: "1800-425-4444",
    phone_no: "0240-2311508",
    email: "Rbca7195@gmail.com",
    social_media,
    ApiUrl,
    apiHeaderJson,
    createSlug
  };
  return (
    <ConfigContext.Provider value={vals}>
      {children}
    </ConfigContext.Provider>
  );
};